var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProLevelThree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 224,
    viewBox: "0 0 224 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_347_7352",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 224,
    height: 224
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 112,
    r: 112,
    fill: "#EAFDDC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_347_7352)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 112,
    r: 112,
    fill: "#EEE6F8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_347_7352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 71.8621L112 56L180 71.8621V208.276L112 240L44 208.276V71.8621Z",
    fill: "url(#paint0_linear_347_7352)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.1163 205.654V75.1287L112 60.2268L175.884 75.1287V205.654L112 235.458L48.1163 205.654Z",
    stroke: "url(#paint1_linear_347_7352)",
    strokeWidth: 8.23253
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1761 207.527V72.7954L112 57.2076L178.824 72.7954V207.527L112 238.702L45.1761 207.527Z",
    stroke: "url(#paint2_linear_347_7352)",
    strokeOpacity: 0.2,
    strokeWidth: 2.35215
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.269 204.051V208.277H100.142V189.242H104.858V204.051H117.272H117.269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.637 189.242V194.506H111.905V189.242H107.189V201.704H111.905V198.759H119.637V208.277H124.324V189.242H119.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5388 131.293H90.1719V133.114H85.6558V135.33H89.3251V137.065H85.6558V139.352H90.3272V141.172H83.5388V131.293ZM95.6659 136.12L92.6034 131.293H95.1155L97.0349 134.426L99.0248 131.293H101.396L98.3332 136.092L101.551 141.172H99.0248L96.9502 137.785L94.805 141.172H92.4482L95.6659 136.12ZM104.092 131.293H108.114C108.829 131.293 109.455 131.43 109.991 131.703C110.527 131.966 110.941 132.342 111.233 132.832C111.534 133.321 111.685 133.899 111.685 134.567C111.685 135.235 111.534 135.819 111.233 136.317C110.941 136.807 110.527 137.188 109.991 137.461C109.455 137.724 108.829 137.856 108.114 137.856H106.209V141.172H104.092V131.293ZM106.209 133.057V136.092H107.916C108.246 136.092 108.528 136.031 108.763 135.908C109.008 135.786 109.196 135.612 109.328 135.386C109.469 135.151 109.539 134.883 109.539 134.582C109.539 134.262 109.474 133.989 109.342 133.763C109.21 133.537 109.022 133.363 108.777 133.241C108.533 133.119 108.246 133.057 107.916 133.057H106.209ZM114.424 131.293H121.057V133.114H116.54V135.33H120.21V137.065H116.54V139.352H121.212V141.172H114.424V131.293ZM124.038 131.293H128.061C128.785 131.293 129.42 131.43 129.966 131.703C130.512 131.975 130.935 132.356 131.236 132.846C131.537 133.326 131.688 133.904 131.688 134.582C131.688 135.212 131.532 135.772 131.222 136.261C130.921 136.741 130.512 137.108 129.994 137.362L131.942 141.172H129.599L127.934 137.856H126.155V141.172H124.038V131.293ZM126.155 133.057V136.092H127.891C128.39 136.092 128.785 135.955 129.077 135.682C129.378 135.41 129.528 135.043 129.528 134.582C129.528 134.111 129.378 133.74 129.077 133.467C128.785 133.194 128.39 133.057 127.891 133.057H126.155ZM133.461 131.293H141.294V133.114H138.429V141.172H136.312V133.114H133.461V131.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.885 75.8279L104.885 124.207H108.047L108.047 75.8279H104.885ZM104.885 154.345L104.885 182.897H108.047L108.047 154.345H104.885ZM110.42 124.207L110.42 75.8279H113.582L113.582 124.207H110.42ZM110.42 154.345L110.42 182.897H113.582L113.582 154.345H110.42ZM115.954 124.207L115.954 75.8279H119.117L119.117 124.207H115.954ZM115.954 154.345L115.954 182.897H119.117L119.117 154.345H115.954Z",
    fill: "url(#paint3_linear_347_7352)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_347_7352",
    x: 44,
    y: 44.2392,
    width: 136,
    height: 195.761,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -11.7608
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.82057
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.192157 0 0 0 0 0.0431373 0 0 0 0 0.0196078 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect1_innerShadow_347_7352"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_347_7352",
    x1: 112,
    y1: 56,
    x2: 112,
    y2: 240,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A882DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#221A2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_347_7352",
    x1: 112,
    y1: 75.8276,
    x2: 112,
    y2: 240,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#221A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A882DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_347_7352",
    x1: 112,
    y1: 153.948,
    x2: 112,
    y2: 240,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_347_7352",
    x1: 112.001,
    y1: 123.811,
    x2: 112.001,
    y2: 182.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProLevelThree);
export default __webpack_public_path__ + "static/media/pro-level-three.48e3419c54b7348bfc61df36c7c2780d.svg";
export { ForwardRef as ReactComponent };